import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import TldrChakraSelect from "apps/simplified-web/src/_components/common/TldrChakraSelect";
import { defaultOptionsStyle } from "apps/simplified-web/src/_components/styled/details/stylesSelect";
import { fetchBrandkitById, switchBrandkit } from "apps/simplified-web/src/_actions/brandKitActions";
import { Box, Button, Center, Flex, Icon, IconButton, Spinner, Text, Tooltip } from "@chakra-ui/react";
import { FaArrowLeft, FaPencilAlt, FaPlus } from "react-icons/fa";
import TldrVideoInAction from "apps/simplified-web/src/TldrAi/TldrVideoInAction";
import { ShowBrandKitInfo, ShowCenterSpinner } from "apps/simplified-web/src/_components/common/statelessView";
import connectedFeatureAvailabilityWrapper from "apps/simplified-web/src/_components/common/withFeatureAvailability";
import { BRANDKIT } from "apps/simplified-web/src/_utils/routes";
import format from "string-format";
import BrandkitAssetsSwiper from "./BrandkitAssetsSwiper";
import BrandkitColorPaletteGrid from './BrandkitColorPaletteGrid';
import BrandkitFontsList from "./BrandkitFontsList";
import EditBrandkitModal from './EditBrandkitModal';
import { VIEW_BRANDKIT_IN_ACTION_VIDEO_LINK } from "../../../constants";
import { openUrl } from '@simplified-workspace/shared/util';

const SectionHeading = ({
  leftSideTitle,
  rightSideTitle,
  rightSideTitleExtraStyles = {},
  onRightSideTitleClick = function () { },
  onLeftSideTitleClick = function () { }
}) => {
  const leftSideTitleStyles = {
    color: "brand.white",
    fontWeight: "bold",
    fontSize: "1rem",
    letterSpacing: "0.13px",
    fontFamily: "Rubik",
  };

  const rightSideTitleStyles = {
    _hover: {
      cursor: "pointer",
    },
  };

  return (
    <Flex direction="row" align="center" justify="space-between" mb="0.25rem">
      <Text
        sx={leftSideTitleStyles}
        onClick={onLeftSideTitleClick}
      >
        {leftSideTitle}
      </Text>
      <Text
        onClick={onRightSideTitleClick}
        sx={{
          ...rightSideTitleExtraStyles,
          ...rightSideTitleStyles
        }}
      >
        {rightSideTitle}
      </Text>
    </Flex>
  );
};

class BrandkitSliderPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      brandkitOptions: [],
      currentBrandkit: null,
      isLoading: false,
      isEditBrandkitModalOpen: false,
      viewAllAssets: false,
    };
  }

  componentDidMount() {
    if (this.props.count > 0) {
      this.setDropdownOptionsAndSwitchBrandkit();
    }
  }

  setDropdownOptionsAndSwitchBrandkit = () => {
    this.setState({ isLoading: true });
    const { brandkits, selectedBrandkit } = this.props;
    let options = this.state.brandkitOptions;

    brandkits.forEach((bk) => {
      options.push({
        value: bk.id,
        label: bk.title,
        palette: bk.palette[0],
        logos: bk.logos,
        fonts: bk.fonts,
      });
    });

    this.setState({
      brandkitOptions: options,
      currentBrandkit: selectedBrandkit
        ? { value: selectedBrandkit.id, label: selectedBrandkit.title }
        : options[0],
    }, () => {
      this.props.fetchBrandkitById(options[0].value)
        .then((responseData) => {
          this.setState({ isLoading: false });
          this.props.switchBrandkit(responseData);
        });
    });
  };

  selectBrandkit = (selected) => {
    this.setState(
      {
        ...this.state,
        currentBrandkit: selected,
        isLoading: true,
      },
      () => {
        this.props.fetchBrandkitById(selected.value)
          .then((responseData) => {
            this.setState({ isLoading: false });
            this.props.switchBrandkit(responseData);
          });
      }
    );
  };

  showAllAssets = () => {
    this.setState({
      ...this.state,
      viewAllAssets: true,
    });
  };

  hideAllAssets = () => {
    this.setState({
      ...this.state,
      viewAllAssets: false,
    });
  };

  addBrandkit = () => {
    const url = format(BRANDKIT);
    openUrl(encodeURI(url), "_blank");
  };

  openEditBrandkitModal = () => {
    this.setState({
      isEditBrandkitModalOpen: true,
    });
  };

  closeEditBrandkitModal = () => {
    this.setState({
      isEditBrandkitModalOpen: false,
    });
  };

  render() {
    const { canvasRef, t, count, selectedBrandkit } = this.props;
    const { brandkitOptions, currentBrandkit, isEditBrandkitModalOpen, isLoading, viewAllAssets } = this.state;

    return (
      <Flex direction="column" h="100%" pr="4">
        {count === 0 ? (
          <Flex h="100%" direction="column" align="center" justify="center">
            <ShowBrandKitInfo text={t("brandkit.text")} />
            <TldrVideoInAction
              title={t("brandkit.setup")}
              videoInAction={VIEW_BRANDKIT_IN_ACTION_VIDEO_LINK}
            ></TldrVideoInAction>
            <Tooltip
              hasArrow
              label={t("brandkit.add")}
            >
              <Button
                leftIcon={<FaPlus />}
                type="submit"
                onClick={this.addBrandkit}
                my="4"
              >
                {t("brandkit.add")}
              </Button>
            </Tooltip>
          </Flex>
        ) : count > 0 && isLoading ? (
          <ShowCenterSpinner loaded={!isLoading}></ShowCenterSpinner>
        ) : count > 0 && !isLoading && selectedBrandkit ? (
          <>
            <Flex direction="row" align="center">
              <TldrChakraSelect
                options={brandkitOptions}
                onChange={this.selectBrandkit}
                value={currentBrandkit}
                defaultValue={currentBrandkit}
                chakraStyles={defaultOptionsStyle}
              />

              <Tooltip label={t("brandkit.edit", { bk_name: selectedBrandkit.title })} hasArrow placement="bottom">
                <IconButton
                  icon={<FaPencilAlt />}
                  ml={3}
                  onClick={this.openEditBrandkitModal}
                />
              </Tooltip>
            </Flex>

            <hr className="tldr-hr" />

            <Flex
              direction="column"
              h="calc(100vh - 272px)"
              overflowY="auto"
              mb="4"
              mt="2"
              sx={{
                "::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {!viewAllAssets ? (
                <Box h="100%">
                  <BrandkitAssetsSwiper
                    canvasRef={canvasRef}
                    viewAll={viewAllAssets}
                    header={
                      <SectionHeading
                        leftSideTitle="Assets"
                        rightSideTitle={
                          selectedBrandkit.logos.length === 0 && !viewAllAssets
                            ? "+ Add"
                            : "View all"
                        }
                        rightSideTitleExtraStyles={
                          selectedBrandkit.logos.length === 0 && !viewAllAssets
                            ? { color: "primary.400" }
                            : {
                              color: "gray.1300",
                              textDecoration: "underline",
                              fontSize: "12px",
                            }
                        }
                        onRightSideTitleClick={
                          selectedBrandkit.logos.length === 0 && !viewAllAssets
                            ? this.openEditBrandkitModal
                            : this.showAllAssets
                        }
                      />
                    }
                  />

                  <BrandkitColorPaletteGrid
                    canvasRef={canvasRef}
                    header={
                      <SectionHeading
                        leftSideTitle="Color Palette"
                        rightSideTitle={selectedBrandkit.palette.length === 0 ? "+ Add" : ""}
                        rightSideTitleExtraStyles={
                          selectedBrandkit.palette.length === 0
                            ? { color: "primary.400" }
                            : {}
                        }
                        onRightSideTitleClick={this.openEditBrandkitModal}
                      />
                    }
                  />

                  <BrandkitFontsList
                    canvasRef={canvasRef}
                    header={
                      <SectionHeading
                        leftSideTitle="Fonts"
                        rightSideTitle={selectedBrandkit.fonts.length === 0 ? "+ Add" : ""}
                        rightSideTitleExtraStyles={
                          selectedBrandkit.fonts.length === 0
                            ? { color: "primary.400" }
                            : {}
                        }
                        onRightSideTitleClick={this.openEditBrandkitModal}
                      />
                    }
                  />
                </Box>
              ) : viewAllAssets ? (
                <BrandkitAssetsSwiper
                  canvasRef={canvasRef}
                  viewAll={viewAllAssets}
                  header={
                    <SectionHeading
                      leftSideTitle={
                        <>
                          <Icon
                            as={FaArrowLeft}
                            color="white"
                            cursor="pointer"
                            mr={1}
                          />
                          Back
                        </>
                      }
                      rightSideTitle={null}
                      rightSideTitleExtraStyles={{}}
                      onLeftSideTitleClick={this.hideAllAssets}
                    />
                  }
                />
              ) : null}
            </Flex>

            {isEditBrandkitModalOpen ? (
              <EditBrandkitModal
                isOpen={isEditBrandkitModalOpen}
                onClose={this.closeEditBrandkitModal}
                brandkit={selectedBrandkit}
              />
            ) : null}
          </>
        ) : null}
      </Flex>
    )
  }
}

const mapStateToProps = (state) => ({
  brandkits: state.brandKit.brandkitPayload,
  selectedBrandkit: state.brandKit.selectedBrandkit,
  count: state.brandKit.brandkitsCount,
});

const mapDispatchToProps = (dispatch) => ({
  switchBrandkit: (id) => dispatch(switchBrandkit(id)),
  fetchBrandkitById: (id) => dispatch(fetchBrandkitById(id)),
});

export default connectedFeatureAvailabilityWrapper(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation(["planner"])(BrandkitSliderPanel))
);
